import React,{ useState,useEffect } from 'react'
import moment from 'moment';
import axios from '../../plugins/axios';
import { useTranslation } from 'react-i18next';
import Toast from '../../plugins/useToast';
import router from '../../router';

import SideMenu from './component/SideMenu';
import UserSetting from './component/UserSettings';
import Account from './component/Account';
import AccountForm from './component/AccountForm'; 
import Department from './component/Department'; 
import PmdMngt from './component/PmdMngt';
import WardMngt from './component/WardMngt';
import ResetPwd from './component/Account/ResetPwd';
import Delete from './component/Common/Delete';
import Add from './component/Common/Add';
import Preference from './component/Preference';
import Hl7Setting from './component/hl7Setting';
import BarcodeLabel from './component/BarcodeLabel';

import "./Common.scss";

const Main = () => {
    const { t, i18n } = useTranslation()
    const [userInfo, setUserInfo] = useState(null);
    const [selectMenu, setSelectMenu] = useState("Account");
    const [isConfirmOpen, setIsConfirmOpen] = useState({
        page : 'account', //account, user 등 페이지 구분
        type : 'delete', // type 구분
        title : '',
        message : '',
        isOpen : false,  
        onYes : null,
        onNo : null,
        errMsg : '',
        key: moment() // Error 메시지가 똑같을 때 Rendering을 강제하기 위해 추가
    });

    // ✅ 메뉴 선택 핸들러
    const handSelectMenu = (menu) => {
        setSelectMenu(menu);
    }

    // ✅ Confirm Modal 열기
    const handleSetConfirm = (page,type, isOpen, onYes = null, onNo = null, errMsg = '',title = '',message = '',maxLength = null) => {         
        setIsConfirmOpen({ page, type, isOpen, onYes, onNo, errMsg, title, message, key: moment(), maxLength });
    }    

    // ✅ Confirm Modal 닫기
    const handleCloseConfirm = () => {
        setIsConfirmOpen({ page: '', type: '', isOpen: false });
    };
    
    // ✅ 사용자 정보 가져오기
    const getUserInfo = async () => {
        try {
            const res = await axios.get('/user/me');
            if(res.code != 200) throw res;

            setUserInfo(res.data);

            if (res?.data?.language) {
                i18n.changeLanguage(res.data.language)
            }
        }
        catch(err) {
            console.error("Error fetching user info:", err);
        }
    }

    // ✅ 선택된 메뉴에 따라 다른 컴포넌트를 렌더링합니다.     
    const renderMenuContent = () => {
        switch (selectMenu) {
            case 'UserSettings':
                return <UserSetting userInfo={userInfo} handleUserInfo={getUserInfo} />;
            case 'Account':
                return <Account handSelectMenu={handSelectMenu} handleSetConfirm={handleSetConfirm} />;
            case 'AccountAdd':
                return <AccountForm mode={'add'} handSelectMenu={handSelectMenu} handleSetConfirm={handleSetConfirm} />;
            case 'AccountEdit':
                return <AccountForm mode={'edit'} handSelectMenu={handSelectMenu} handleSetConfirm={handleSetConfirm} />;
            case 'Department':
                return <Department handleSetConfirm={handleSetConfirm} handleCloseConfirm={handleCloseConfirm}/>;
            case 'PmdMngt':
                return <PmdMngt handleSetConfirm={handleSetConfirm} />;
            case 'WardMngt':
                return <WardMngt handleSetConfirm={handleSetConfirm} handleCloseConfirm={handleCloseConfirm} />;
            case 'Preferences':
                return <Preference />;
            case 'HL7':
                return <Hl7Setting />;
            case 'BarcodeLabel':
                return <BarcodeLabel />;
            default:
                return null;
        }
    }

    // ✅ 컴포넌트가 마운트될 때 사용자 정보를 가져옵니다.
    useEffect(() => {
        const userId = localStorage.getItem('AdmincmsUserId');
        if (!userId) {
            router.navigate('/admin');
            //Toast({ isSuccess: false, msg: t('admin.loginRequired') });
            return;
        }else {
            getUserInfo();
        }

    }, [])

    return (
        <div className="fix flex w-full h-full bg-[#29292E] ">
            <SideMenu userInfo={userInfo} selectMenu={selectMenu} handSelectMenu={handSelectMenu}/>
            <div className="relative w-[calc(100%-320px)] h-full bg-[#29292E] p-[40px]">
                {renderMenuContent()}
            </div>
            
            {/* Delete */}
            {
                isConfirmOpen.type == 'delete' && isConfirmOpen.isOpen && (
                    <Delete
                        isOpen={isConfirmOpen.isOpen}                        
                        message={isConfirmOpen.message}
                        cancelText={t('admin.cancel')}
                        confirmText={t('admin.ok')}
                        onConfirm={() => { isConfirmOpen.onYes(); handleCloseConfirm(); }}
                        onCancel={handleCloseConfirm}
                    />
                )
            }

            {/* Add */}
            {
                isConfirmOpen.type == 'add' && isConfirmOpen.isOpen && (
                    <Add 
                        page={isConfirmOpen.page}
                        key={isConfirmOpen.key}
                        isOpen={isConfirmOpen.isOpen}
                        title={isConfirmOpen.title}
                        onOk={(...args) => {isConfirmOpen.onYes(...args);}} 
                        onCancel={handleCloseConfirm}
                        errMsg={isConfirmOpen.errMsg}
                        maxLength={isConfirmOpen.maxLength}
                    />
                )
            }

            {/* Reset Password */}
            {
                isConfirmOpen.page == 'account' &&  (isConfirmOpen.type =='resetPwd' || isConfirmOpen.type =='resetPwd2') && isConfirmOpen.isOpen && (
                    <ResetPwd 
                        isOpen={isConfirmOpen.isOpen}
                        type={isConfirmOpen.type}                        
                        title={t(`admin.Account.confirm.resetPwdTitle`)}
                        message={t(`admin.Account.confirm.${isConfirmOpen.type}`)}
                        errMsg={isConfirmOpen.errMsg}
                        onOk={isConfirmOpen.type =='resetPwd' ? isConfirmOpen.onYes : (...args) => {isConfirmOpen.onYes(...args); handleCloseConfirm(); }} 
                        onCancel={handleCloseConfirm}
                    />
                )
            }

        </div>
    )
}

export default Main